// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { CdkPortal, TemplatePortal } from '@angular/cdk/portal';
import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { ButtonComponent } from '@lbca-shared/button';
import { IconComponent } from '@lbca-shared/icon';
import moment from 'moment';
import { ErrorOverlayClass } from '../../../../components/_old_components/error-overlay/error-overlay.directive';
import { CheckDateRulesPipe } from '../../../../helpers/_old_helpers/checkDateRules.pipe';
import {
  OverlayHelper,
  overlayUserConfiguration,
} from '../../../../helpers/_old_helpers/overlayHelperClass';
import { InputTextComponent } from '../input-text/input-text.component';

@Component({
  selector: 'lbca-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrl: './date-picker.component.scss',
  imports: [
    InputTextComponent,
    CdkPortal,
    NgClass,
    CheckDateRulesPipe,
    IconComponent,
    ButtonComponent,
  ],
})
export class DatePickerComponent implements AfterViewInit, OnDestroy {
  @HostListener('keydown', ['$event'])
  onEsc(event: any) {
    if (event.key === 'Escape') {
      this.closePicker();
    }
  }

  @HostListener('document:click', ['$event'])
  public outClick(event: MouseEvent) {
    if (this.clickedInside) {
      this.clickedInside = false;
      return;
    }
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closePicker();
    }
  }

  private errorPopup!: ErrorOverlayClass;

  private datePickerOverlay!: OverlayHelper;

  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
  @ViewChild('templateAppend', { static: true }) templateAppend!: TemplatePortal;

  public clickedInside = false;
  public labelValue = '';
  public helperTextValue = '';
  public isRequired = false;
  public isDisabled = false;
  public isLabeled = false;
  public isTabeled = false;
  public isEditable = false;
  public minValue: any = null;
  public maxValue: any = null;

  public valueInput: any = null;
  public position: 'top' | 'bottom' = 'bottom';

  public baseMonth = 0;
  public baseYear = 0;

  public baseDate = 'jun de 2019';
  public intervalYears!: string;
  public calendar: any;
  public weekDays: any[] = [];
  public yearMonths: any[] = [];
  public years: any[] = [];
  public weekSelect;

  public hasError = false;

  public typeSelection: 'calendar' | 'month' | 'year' = 'calendar';
  private holidays: string[] = [
    '01/01',
    '15/04',
    '21/04',
    '01/05',
    '07/09',
    '12/10',
    '02/11',
    '15/11',
    '25/12',
  ];
  public pipeArgs = {};

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      console.log(error);
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set value(val: string | number) {
    if (val) {
      this.valueInput = val;
      if (typeof this.valueInput === 'string') {
        this.change(this.valueInput);
      }
    }
  }

  private elementRef: any;

  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set min(value: number) {
    this.minValue = value;
  }
  @Input() set max(value: number) {
    this.maxValue = value;
  }
  @Input() rules: Array<any> = [];
  @Input() disabledDateRules: Array<any> = [];

  @Input() set calendarPosition(value: 'top' | 'bottom') {
    this.position = value;
    if (this.position === 'top') {
      this.errorPopup.setPosition(
        this.elementRef,
        [
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
        ],
        0,
        0,
        'top',
        'end'
      );
    }
  }

  @Output('changeValue') changeEmmiter = new EventEmitter();

  @Output() focusState = new EventEmitter();

  @Output('setError') setErrorEmmiter = new EventEmitter();

  @Output('validStatus') validStatusEmmiter = new EventEmitter();

  public icon = 'lucide:calendar';

  constructor() {
    const overlay = inject(Overlay);
    const elementRef = inject(ElementRef);

    this.inicializateDate();
    this.datePickerOverlay = new OverlayHelper(overlay);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'end'
    );

    this.elementRef = elementRef;
  }

  ngOnDestroy(): void {
    this.closePicker();
  }

  ngAfterViewInit(): void {
    // USE GET SIZE TO ERRO
    // this.bindProperties.width = Math.round(this.mainElement.nativeElement.getBoundingClientRect().width);

    const config: overlayUserConfiguration = {
      positionStrategy: 'flexible',
      scrollStrategy: 'close',
      offsetY: this.position === 'top' ? -425 : 0,
      connectedTo: this.mainElement,
      flexiblePositionStrategy: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
      ],
    };

    this.datePickerOverlay.setConfiguration(config);
    this.pipeArgs = {
      min: this.min,
      max: this.max,
      minValue: this.minValue,
      maxValue: this.maxValue,
      holidays: this.holidays,
    };
  }

  // Bloqueia clicks dentro do calendario retirar o focus do mesmo
  public eventBlockFocusOut($event) {
    $event.preventDefault();
  }

  public click() {
    const focusedElement = document.activeElement;
    if (focusedElement instanceof HTMLInputElement) {
      this.icon = 'lucide:chevron-down';
      this.setFocus(true);
    }
  }

  public setFocus(focus): void {
    this.focusState.emit(focus);
    if (focus) {
      this.icon = 'lucide:calendar';
      this.typeSelection = 'calendar';
      this.openPicker();
    } else {
      this.icon = 'lucide:calendar';
    }
  }

  private openPickerOverlay(): void {
    this.datePickerOverlay.show(this.templateAppend);
  }

  private closePicker(): void {
    this.datePickerOverlay.close();
    this.errorPopup.setFocus(false);
    this.setFocus(false);
  }

  private openPicker() {
    // Aqui da scroll para baixo, para certificar que o calendário caiba na página

    const config: overlayUserConfiguration = {
      positionStrategy: 'flexible',
      scrollStrategy: 'close',
      offsetY: this.position === 'top' ? -425 : 0,
      connectedTo: this.mainElement,
      flexiblePositionStrategy: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
      ],
    };

    this.datePickerOverlay.setConfiguration(config);

    const availHeight = Math.round(window.innerHeight);
    const topDistance = Math.round(this.mainElement.nativeElement.getBoundingClientRect().top);
    const spaceDisponible = availHeight - (topDistance + 52);

    const spaceBottomDisponible = availHeight - spaceDisponible - 32;

    if (spaceDisponible < 378 && this.position === 'bottom') {
      const spaceNecessary = 382 - spaceDisponible;

      let scroll = document.getElementById('main-scroll');

      if (scroll === null) {
        scroll = document.getElementById('modal-scroll')!;
      }

      const scrollPosition = Math.round(scroll!.scrollTop);
      const newPosition = scrollPosition + spaceNecessary;
      let scrollAnimation = scrollPosition;
      const sumConst = Math.round(spaceNecessary / 100);

      // Suavização do scroll
      const interval = setInterval(() => {
        scrollAnimation += sumConst;
        scroll!.scrollTop = scrollAnimation;
      }, 4);

      setTimeout(() => {
        clearInterval(interval);
        scroll!.scrollTop = newPosition;
        setTimeout(() => this.openPickerOverlay(), 150);
      }, 402);
    } else {
      if (spaceBottomDisponible < 378 && this.position === 'top') {
        const spaceNecessary = 382 - spaceBottomDisponible;

        let scroll = document.getElementById('main-scroll');

        if (scroll === null) {
          scroll = document.getElementById('modal-scroll')!;
        }

        const scrollPosition = Math.round(scroll!.scrollTop);
        const newPosition = scrollPosition + spaceNecessary;
        let scrollAnimation = scrollPosition;
        const sumConst = Math.round(spaceNecessary / 100);
        // Suavização do scroll
        const interval = setInterval(() => {
          scrollAnimation -= sumConst;
          scroll!.scrollTop = scrollAnimation;
        }, 4);

        setTimeout(() => {
          clearInterval(interval);
          scroll!.scrollTop = newPosition;

          const availHeight = Math.round(window.innerHeight);
          const topDistance = Math.round(
            this.mainElement.nativeElement.getBoundingClientRect().top
          );
          const spaceDisponible = availHeight - (topDistance + 52);

          const spaceBottomDisponible = availHeight - spaceDisponible - 32;

          if (spaceBottomDisponible < 378) {
            const config: overlayUserConfiguration = {
              positionStrategy: 'fixed',
              scrollStrategy: 'close',
              offsetY: 0,
              connectedTo: this.mainElement,
              flexiblePositionStrategy: [
                {
                  originX: 'start',
                  originY: 'bottom',
                  overlayX: 'start',
                  overlayY: 'top',
                },
              ],
            };

            this.datePickerOverlay.setConfiguration(config);
          }

          setTimeout(() => this.openPickerOverlay(), 150);
        }, 402);
      } else {
        setTimeout(() => this.openPickerOverlay(), 150);
      }
    }
  }

  private inicializateDate(): void {
    this.baseMonth = Number(moment().format('MM')) - 1;
    this.baseYear = Number(moment().format('YYYY'));

    this.getDate();
    this.getYears();
    this.getMonth();

    for (let index = 0; index < 7; index++) {
      const weekDay = moment().startOf('week').add(index, 'day').format('ddd');
      this.weekDays.push({ index: weekDay, label: weekDay.slice(0, 1) });
    }

    for (let index = 0; index < 12; index++) {
      const month = moment().startOf('year').add(index, 'month').format('MMM');
      this.yearMonths.push({ index, label: month });
    }

    for (let index = 0; index < 12; index++) {
      const year = moment().startOf('year').subtract(6, 'year').add(index, 'year').format('YYYY');
      this.years.push({ index, label: year });
    }
  }

  private getDate(): void {
    const month = moment().year(this.baseYear).month(this.baseMonth).format('MMMM');
    this.baseDate = `${month}, ${this.baseYear}`;
  }

  private getYears(): void {
    const initYear = moment().year(this.baseYear).subtract(6, 'year').format('YYYY');
    const endYear = moment().year(this.baseYear).add(5, 'year').format('YYYY');
    this.intervalYears = `${initYear} - ${endYear}`;
  }

  public changePeriod(choise): void {
    if (this.typeSelection === 'calendar') {
      if (choise === 'next') {
        if (this.baseMonth > 10) {
          this.baseMonth = 0;
          this.baseYear += 1;
        } else this.baseMonth += 1;
      } else if (choise === 'previus') {
        if (this.baseMonth < 1) {
          this.baseMonth = 11;
          this.baseYear = this.baseYear - 1;
        } else this.baseMonth -= 1;
      }
    } else {
      if (this.typeSelection === 'year') {
        if (choise === 'next') this.baseYear += 12;
        else this.baseYear = this.baseYear - 12;

        this.years = [];
        for (let index = 0; index < 12; index++) {
          const year = moment()
            .year(this.baseYear)
            .subtract(6, 'year')
            .add(index, 'year')
            .format('YYYY');
          this.years.push({ index, label: year });
        }
      } else {
        if (choise === 'next') this.baseYear += 1;
        else this.baseYear = this.baseYear - 1;
      }
    }
    this.getDate();
    this.getYears();
    this.getMonth();
  }

  private getMonth(): void {
    const date = moment().year(this.baseYear).month(this.baseMonth);
    let startWeek = date.startOf('month').week();
    let endWeek = date.endOf('month').week();
    const lastWeekofYear = date.endOf('year').subtract(1, 'week').week();
    const primeirodia = Number(date.week(startWeek).startOf('week').format('DD'));

    if (primeirodia < 10 && primeirodia > 1) {
      startWeek = startWeek - 1;
    }

    if (endWeek === 1) {
      endWeek = lastWeekofYear;
    }

    const temporaryCalendar: any[] = [];
    for (let week = startWeek; week <= endWeek; week++) {
      if (week <= lastWeekofYear) {
        temporaryCalendar.push({
          days: Array(7)
            .fill(0)
            .map((n, i) =>
              date
                .week(week)
                .startOf('week')
                .clone()
                .add(n + i, 'day')
            ),
        });

        if (week === endWeek && week === lastWeekofYear) {
          temporaryCalendar.push({
            days: Array(7)
              .fill(0)
              .map((n, i) =>
                moment()
                  .year(this.baseYear + 1)
                  .month(1)
                  .week(1)
                  .startOf('week')
                  .clone()
                  .add(n + i, 'day')
              ),
          });
        }
      } else {
        temporaryCalendar.push({
          days: Array(7)
            .fill(0)
            .map((n, i) =>
              date
                .week(week)
                .startOf('week')
                .clone()
                .add(n + i, 'day')
            ),
        });
        temporaryCalendar.push({
          days: Array(7)
            .fill(0)
            .map((n, i) =>
              moment()
                .year(this.baseYear + 1)
                .month(1)
                .week(1)
                .startOf('week')
                .clone()
                .add(n + i, 'day')
            ),
        });
      }
    }

    this.calendar = temporaryCalendar;
  }

  public getDayMathSelect(day) {
    if (!this.weekSelect) return false;

    if (typeof day === 'string') {
      if (this.weekSelect.format('ddd') === day) return true;
      return false;
    }

    if (this.weekSelect.format('ddd') === day.format('ddd')) {
      if (this.weekSelect.diff(day) > 0) return true;
    }
    return false;
  }
  public getDayMathMonth(day) {
    if (this.baseMonth + 1 === Number(day.format('M'))) return true;
    return false;
  }

  public changeTypeSelection() {
    if (this.typeSelection === 'calendar') {
      this.typeSelection = 'month';
    } else {
      if (this.typeSelection === 'month') this.typeSelection = 'year';
      else this.typeSelection = 'calendar';
    }
  }

  public selectYear(year) {
    this.baseYear = Number(this.years[year].label);
    this.getDate();
    this.getYears();
    this.getMonth();
    this.typeSelection = 'month';
  }

  public selectMonth(month) {
    this.baseMonth = month;
    this.getDate();
    this.getYears();
    this.getMonth();
    this.typeSelection = 'calendar';
  }

  public selectDay(day) {
    this.setErrorEmmiter.emit([]);
    // Antes de selecionar a data verifica as regras
    const resp = this.checkRulesDate(day);
    if (resp.error) {
      this.showError(true, resp.details);
      return;
    }

    this.errorPopup.cleanErros();

    this.weekSelect = null;
    const data = moment(day).format('DD / MM / YYYY');
    this.valueInput = data;
    // this.changeEmmiter.emit(data);
    this.closePicker();
  }

  public change($event) {
    const resp = this.checkRulesDate(moment($event, 'X'));
    if (resp.error) {
      this.valueInput = '';
      this.showError(true, resp.details);
      return;
    }
    this.errorPopup.cleanErros();
    this.changeEmmiter.emit($event);
    //this.closePicker();
  }

  checkRulesDate(day: moment.Moment) {
    // Se esse método retornar false é pq alguma regra não passou
    const today = moment().format('YYYY-MM-DD'); // pega a data d o dia atual
    const resp = { details: [] as any[], error: false, params: [] as any[] };
    try {
      resp.details = [];
      resp.error = false;

      if (Array.isArray(this.rules)) {
        this.rules.forEach((rule) => {
          /* Loop nas regras */
          switch (
            rule // verifica regras
          ) {
            case 'du>=d':
              if (!moment(day).isAfter(today) && !moment(day).isSame(today)) {
                resp.details.push('A data informada deve ser igual ou maior que a data de hoje');
                resp.error = true;
              }
              break;
            case 'du>d':
              if (!moment(day).isAfter(today)) {
                resp.details.push('A data informada deve ser maior que a data de hoje');
                resp.error = true;
              }
              break;
            case 'du<=d':
              if (!moment(day).isBefore(today) && !moment(day).isSame(today)) {
                resp.details.push('A data informada deve ser igual ou menor que a data de hoje');
                resp.error = true;
              }
              break;
            case 'du<d':
              if (!moment(day).isBefore(today)) {
                resp.details.push('A data informada deve ser menor que a data de hoje');
                resp.error = true;
              }
              break;
            case 'du>=mn':
              if (
                this.min &&
                !moment(day).isAfter(moment.unix(this.min)) &&
                !moment(day).isSame(moment.unix(this.min))
              ) {
                resp.details.push('A data informada deve ser igual ou maior que a data mínima');
                resp.error = true;
              }
              break;
            case 'du>mn':
              if (!moment(day).isAfter(moment.unix(this.min))) {
                resp.details.push('A data informada deve ser maior que a data mínima');
                resp.error = true;
              }
              break;
            case 'du<=mx':
              if (
                this.max &&
                !moment(day).isBefore(moment.unix(this.max)) &&
                !moment(day).isSame(moment.unix(this.max))
              ) {
                resp.details.push('A data informada deve ser igual ou menor que a data máxima');
                resp.error = true;
              }
              break;
            case 'du<mx':
              if (this.max && !moment(day).isBefore(moment.unix(this.max))) {
                resp.details.push('A data informada deve ser menor que a data máxima');
                resp.error = true;
              }
              break;
            default:
            // console.warn("invalid rule");
          }
        });
      }

      if (Array.isArray(this.disabledDateRules)) {
        this.disabledDateRules.forEach((disabledDateRule) => {
          let applyRule = false;
          const { conditions = {} } = disabledDateRule;

          const ops = {
            gte: (value) => moment().isSameOrAfter(value),
            gt: (value) => moment().isAfter(value),
            lte: (value) => moment().isSameOrBefore(value),
            lt: (value) => moment().isBefore(value),
          };

          const types = {
            time: (op, value) => ops[op](moment(value, 'hh:mm')),
          };

          if (Array.isArray(conditions?.or)) {
            const orRulesSatisfied = conditions.or.filter((orRule) =>
              types[orRule.type](orRule.op, orRule[orRule.type])
            );
            applyRule = orRulesSatisfied.length === conditions.or.length;
          }

          if (Array.isArray(conditions?.and)) {
            const andRulesSatisfied = conditions.and.filter((andRule) =>
              types[andRule.type](andRule.op, andRule[andRule.type])
            );
            applyRule = andRulesSatisfied.length === conditions.and.length;
          }

          if (conditions?.always) applyRule = true;

          if (applyRule) {
            switch (disabledDateRule.rule) {
              case 'sunday':
                if (day.isoWeekday() === 7) {
                  resp.details.push('A data informada não pode ser um domingo');
                  resp.error = true;
                }
                break;
              case 'saturday':
                if (day.isoWeekday() === 6) {
                  resp.details.push('A data informada não pode ser um sábado');
                  resp.error = true;
                }
                break;
              case 'holidays':
                if (this.holidays.includes(day.format('DD/MM'))) {
                  resp.details.push('A data informada não pode ser um feriado nacional');
                  resp.error = true;
                }
                break;
              case 'nextBusinessday':
                // eslint-disable-next-line no-case-declarations
                let current = moment(day.format('DDMMYYYY'), 'DDMMYYYY');
                for (let index = 0; index < disabledDateRule.quantity || index > 100; ) {
                  current = current.subtract(1, 'days');
                  if (
                    !(
                      current.isoWeekday() === 7 ||
                      current.isoWeekday() === 6 ||
                      this.holidays.includes(current.format('DD/MM'))
                    )
                  ) {
                    index++;
                  }
                }

                if (moment(current).isBefore(today) || moment(current).isSame(today)) {
                  resp.details.push(
                    `A data informada deve ser posterior ao(s) próximo(s) ${disabledDateRule.quantity} dia(s) útil(eis)`
                  );
                  resp.error = true;
                }
                break;
              case 'lt':
                if (day.isBefore(moment().startOf('day'))) {
                  resp.details.push('A data informada deve ser posterior a data atual');
                  resp.error = true;
                }
                break;
              case 'lte':
                if (day.isSameOrBefore(moment().endOf('day'))) {
                  resp.details.push('A data informada deve ser posterior ou igual a data atual');
                  resp.error = true;
                }
                break;
              case 'gt':
                if (day.isAfter(moment().endOf('day'))) {
                  resp.details.push('A data informada deve ser anterior a data atual');
                  resp.error = true;
                }
                break;
              case 'gte':
                if (day.isSameOrAfter(moment().startOf('day'))) {
                  resp.details.push('A data informada deve ser anterior ou igual a data atual');
                  resp.error = true;
                }
                break;
              case 'ltmn':
                if (day.isBefore(moment.unix(this.minValue).startOf('day'))) {
                  resp.details.push(
                    'A data informada deve ser posterior ou igual a ' +
                      moment.unix(this.minValue).format('DD/MM')
                  );
                  resp.error = true;
                }
                break;
              case 'ltemn':
                if (day.isSameOrBefore(moment.unix(this.minValue).endOf('day'))) {
                  resp.details.push(
                    'A data informada deve ser posterior a ' +
                      moment.unix(this.minValue).format('DD/MM')
                  );
                  resp.error = true;
                }
                break;
              case 'gtmx':
                if (day.isAfter(moment.unix(this.maxValue).endOf('day'))) {
                  resp.details.push(
                    'A data informada deve ser anterior ou igual a ' +
                      moment.unix(this.maxValue).format('DD/MM')
                  );
                  resp.error = true;
                }
                break;
              case 'gtemx':
                if (day.isSameOrAfter(moment.unix(this.maxValue).startOf('day'))) {
                  resp.details.push(
                    'A data informada deve ser anterior a ' +
                      moment.unix(this.maxValue).format('DD/MM')
                  );
                  resp.error = true;
                }
                break;
              default:
                console.warn('invalid rule');
            }
          }
        });
      }
    } catch (e) {
      resp.details = ['Não há regras de data'];
      resp.error = false;
    }
    return resp;
  }

  showError(hasError: boolean, setErrors: Array<any>) {
    this.hasError = hasError;
    this.errorPopup.setErrors(setErrors);
  }
}
